var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_2387)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.9379 9.848C26.8445 9.84694 25.7961 9.41211 25.0229 8.63894C24.2498 7.86577 23.815 6.81743 23.8139 5.724V0H5.38589C4.67895 -4.8812e-08 3.97894 0.139267 3.32583 0.409863C2.67273 0.680459 2.07933 1.07707 1.57954 1.57705C1.07975 2.07703 0.683342 2.67057 0.412989 3.32378C0.142635 3.97698 0.00364392 4.67707 0.00390662 5.38401V37.826C0.00364392 38.5329 0.142635 39.233 0.412989 39.8862C0.683342 40.5394 1.07975 41.133 1.57954 41.6329C2.07933 42.1329 2.67273 42.5295 3.32583 42.8001C3.97894 43.0707 4.67895 43.21 5.38589 43.21H27.5059C28.9338 43.21 30.3033 42.6428 31.313 41.6331C32.3227 40.6234 32.8899 39.2539 32.8899 37.826V9.85L27.9379 9.848Z",
    fill: "#A140FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8899 9.848H27.9379C26.8445 9.84694 25.7962 9.41211 25.023 8.63894C24.2498 7.86577 23.815 6.81743 23.814 5.724V0L32.8899 9.848Z",
    fill: "#A140FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7917 34.1201H11.7837C10.0098 34.1201 8.57178 35.5582 8.57178 37.3321V44.7881C8.57178 46.562 10.0098 48.0001 11.7837 48.0001H36.7917C38.5657 48.0001 40.0038 46.562 40.0038 44.7881V37.3321C40.0038 35.5582 38.5657 34.1201 36.7917 34.1201Z",
    fill: "#A140FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7301 42.6741V44.1301H15.2241V42.6741H16.7301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8038 38.116V39.272H20.1718V44.13H18.7078V39.272H17.0918V38.116H21.8038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8759 38.116V44.13H22.4199V38.116H23.8759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8038 38.116V39.272H26.3378V40.59H28.2438V41.696H26.3378V44.13H24.8838V38.116H28.8038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4698 38.116V39.272H31.0038V40.59H32.9098V41.696H31.0038V44.13H29.5498V38.116H33.4698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8661 29.2821H12.03C11.1652 29.281 10.3362 28.937 9.72466 28.3255C9.11314 27.714 8.76912 26.8849 8.76807 26.0201V17.1861C8.76912 16.3213 9.11314 15.4922 9.72466 14.8807C10.3362 14.2691 11.1652 13.9251 12.03 13.9241H20.8661C21.7303 13.9257 22.5587 14.27 23.1695 14.8815C23.7802 15.493 24.1235 16.3218 24.1241 17.1861V26.0201C24.1235 26.8843 23.7802 27.7131 23.1695 28.3247C22.5587 28.9362 21.7303 29.2805 20.8661 29.2821ZM12.03 15.3661C11.5475 15.3666 11.0849 15.5585 10.7437 15.8997C10.4025 16.2409 10.2106 16.7036 10.2101 17.1861V26.0201C10.2106 26.5026 10.4025 26.9652 10.7437 27.3064C11.0849 27.6476 11.5475 27.8395 12.03 27.8401H20.8661C21.3482 27.839 21.8104 27.6469 22.1511 27.3057C22.4919 26.9646 22.6835 26.5023 22.684 26.0201V17.1861C22.6835 16.7039 22.4919 16.2416 22.1511 15.9004C21.8104 15.5593 21.3482 15.3671 20.8661 15.3661H12.03Z",
    fill: "#A140FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4038 24.34V26.02C23.4038 26.6933 23.1364 27.3391 22.6605 27.8154C22.1846 28.2917 21.5391 28.5595 20.8658 28.5601H12.0297C11.3561 28.5601 10.71 28.2924 10.2337 27.8161C9.75735 27.3397 9.48975 26.6937 9.48975 26.02V23.2C10.9037 22.896 13.0578 22.8 15.6738 23.844L17.2917 22.3L18.3958 25.1C18.3958 25.1 18.6918 24.07 19.6478 24.216C20.6038 24.362 22.1518 24.88 22.8138 24.438C22.9921 24.3351 23.2017 24.3003 23.4038 24.34Z",
    fill: "#A140FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3121 18.9899C20.8545 18.9899 21.2941 18.5502 21.2941 18.0079C21.2941 17.4655 20.8545 17.0259 20.3121 17.0259C19.7698 17.0259 19.3301 17.4655 19.3301 18.0079C19.3301 18.5502 19.7698 18.9899 20.3121 18.9899Z",
    fill: "#A140FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_2387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48,
    fill: "white",
    transform: "translate(0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/TIFF.3f51665d538a2d44b8af6d64108db1d7.svg";
export { ForwardRef as ReactComponent };